import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/filtrarPedido`, method: 'POST', body: values, token: token})
}
